<header class="topbar">
  <div class="topbar-left">
    <!-- Only rendered below the drawer breakpoint; above it the sidebar is
         always there and a toggle would be a control with nothing to do. -->
    <button type="button" class="nav-toggle"
            [attr.aria-expanded]="navOpen"
            aria-controls="app-sidebar"
            [attr.aria-label]="navOpen ? 'Close navigation' : 'Open navigation'"
            (click)="onToggleNav($event)">
      <i class="fa-solid" [ngClass]="navOpen ? 'fa-xmark' : 'fa-bars'"></i>
    </button>
    <h1 class="page-title">{{ getPageTitle() }}</h1>
  </div>
  <div class="topbar-right">
    <div class="user-menu" (click)="toggleDropdown($event)">
      <div class="avatar">{{ auth.currentUser()?.name?.charAt(0) | uppercase }}</div>
      <span class="user-name-top">{{ auth.currentUser()?.name }}</span>
      <span class="chevron">›</span>
      <div class="dropdown" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">
        <a routerLink="/profile" class="dropdown-item" (click)="dropdownOpen = false">Profile</a>
        <hr class="dropdown-divider">
        <button class="dropdown-item danger" (click)="logout()">Sign out</button>
      </div>
    </div>
  </div>
</header>
